/* generated using openapi-typescript-codegen -- do no edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { CreateTSPBody } from '../models/CreateTSPBody';
import type { TSP1 } from '../models/TSP1';
import type { UpdateTSPBody } from '../models/UpdateTSPBody';

import type { CancelablePromise } from '../core/CancelablePromise';
import type { BaseHttpRequest } from '../core/BaseHttpRequest';

export class TspsService {

  constructor(public readonly httpRequest: BaseHttpRequest) {}

  /**
   * @returns TSP1 Details of a single TSP
   * @throws ApiError
   */
  public restoreTsp({
    id,
  }: {
    id: string,
  }): CancelablePromise<TSP1> {
    return this.httpRequest.request({
      method: 'POST',
      url: '/motor/tsps/{id}/restore',
      path: {
        'id': id,
      },
      errors: {
        400: `Malformed Error`,
        401: `Auth Error`,
        403: `Forbidden Error`,
        422: `Invalid Error`,
      },
    });
  }

  /**
   * @returns TSP1 Details of a single TSP
   * @throws ApiError
   */
  public archiveTsp({
    id,
  }: {
    id: string,
  }): CancelablePromise<TSP1> {
    return this.httpRequest.request({
      method: 'POST',
      url: '/motor/tsps/{id}/archive',
      path: {
        'id': id,
      },
      errors: {
        400: `Malformed Error`,
        401: `Auth Error`,
        403: `Forbidden Error`,
        422: `Invalid Error`,
      },
    });
  }

  /**
   * @returns TSP1 Details of a single TSP
   * @throws ApiError
   */
  public updateTsp({
    id,
    requestBody,
  }: {
    id: string,
    /**
     * The TSP
     */
    requestBody: UpdateTSPBody,
  }): CancelablePromise<TSP1> {
    return this.httpRequest.request({
      method: 'POST',
      url: '/motor/tsps/{id}',
      path: {
        'id': id,
      },
      body: requestBody,
      mediaType: 'application/json',
      errors: {
        400: `Malformed Error`,
        401: `Auth Error`,
        403: `Forbidden Error`,
        422: `Invalid Error`,
      },
    });
  }

  /**
   * @returns TSP1 Details of a single TSP
   * @throws ApiError
   */
  public findTsp({
    id,
  }: {
    id: string,
  }): CancelablePromise<TSP1> {
    return this.httpRequest.request({
      method: 'GET',
      url: '/motor/tsps/{id}',
      path: {
        'id': id,
      },
      errors: {
        400: `Malformed Error`,
        401: `Auth Error`,
        403: `Forbidden Error`,
        404: `Not Found Error`,
      },
    });
  }

  /**
   * @returns TSP1 An array of TSP Details
   * @throws ApiError
   */
  public searchTsps({
    status,
  }: {
    status?: 'active' | 'archived',
  }): CancelablePromise<Array<TSP1>> {
    return this.httpRequest.request({
      method: 'GET',
      url: '/motor/tsps',
      query: {
        'status': status,
      },
      errors: {
        400: `Malformed Error`,
        401: `Auth Error`,
        403: `Forbidden Error`,
        422: `Invalid Error`,
      },
    });
  }

  /**
   * @returns TSP1 Details of a single TSP
   * @throws ApiError
   */
  public createTsp({
    requestBody,
  }: {
    /**
     * The TSP
     */
    requestBody: CreateTSPBody,
  }): CancelablePromise<TSP1> {
    return this.httpRequest.request({
      method: 'POST',
      url: '/motor/tsps',
      body: requestBody,
      mediaType: 'application/json',
      errors: {
        400: `Malformed Error`,
        401: `Auth Error`,
        403: `Forbidden Error`,
        422: `Invalid Error`,
      },
    });
  }

}
